export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"m16 9.5 3-3h-6zm-11-6h14.01c1.1 0 1.99.9 1.99 2v5c0 1.101-.9 2-2 2H4.99c-1.1 0-1.99-.899-1.99-2v-5c0-1.1.9-2 2-2M3 18.498h18c0 1.101-.9 2-2 2H4.99c-1.1 0-1.99-.899-1.99-2M3 14.5h18c0 1.1-.9 2-2 2H4.99c-1.1 0-1.99-.9-1.99-2\"/>"
};